import { Attributes } from '@leverege/ui-attributes'
import { Projection } from '@leverege/ui-linear-view-elements'
import React from 'react'

import { OperatingHours } from '@leverege/operating-hours'
import { DateTime } from 'luxon'
import { getStationOccupancyItems } from '../../../util/Stations'

import TableSplitView from './TableSplitView'

// export default class StationTimeline extends React.Component {
export default function StationTimeline( props ) {
  const { result, data, selected, parentItem } = props

  const operatingHours = parentItem.data?.metadata?.operatingHours?.default

  const items = getStationOccupancyItems( result.items || [], data.items )

  const { bins } = items
  let { minTime, maxTime } = items

  if ( !minTime || !maxTime ) {
    return null
  }

  minTime = DateTime
    .fromMillis( minTime )
    .setZone( operatingHours.timezone )
    .startOf( 'day' )
    .valueOf()
  maxTime = DateTime
    .fromMillis( maxTime )
    .setZone( operatingHours.timezone )
    .endOf( 'day' )
    .valueOf()

  const minDate = new Date( minTime )
  const maxDate = new Date( maxTime )

  const startTime = OperatingHours.getIsOpen( operatingHours, minDate ) ?
    OperatingHours.getLastOpenTimestamp( operatingHours, minDate ) :
    OperatingHours.getNextOpenTimestamp( operatingHours, minDate )
  const stopTime = OperatingHours.getIsOpen( operatingHours, maxDate ) ?
    OperatingHours.getNextCloseTimestamp( operatingHours, maxDate ) :
    OperatingHours.getLastCloseTimestamp( operatingHours, maxDate )

  minTime = DateTime
    .fromJSDate( startTime )
    .minus( { hour : 1 } )
    .valueOf()
  maxTime = DateTime
    .fromJSDate( stopTime )
    .plus( { hour : 1 } )
    .valueOf()

  const keys = [ ...bins.entries() ]
    .sort( ( [ , dataA ], [ , dataB ] ) => {
      const nameA = Attributes.get( 'name', dataA.obj )
      const nameB = Attributes.get( 'name', dataB.obj )

      return nameA < nameB ? -1 : 1
    } )
    .map( item => item[0] )

  const hdrData = keys.map( ( k ) => { return bins.get( k ).obj } ).filter( i => i != null )
  const rows = keys.map( ( k ) => { return bins.get( k ).events } ).filter( i => i != null )
  const proj = new Projection( { pixelValue : 30000, startValue : minTime, stopValue : maxTime } )

  return (
    <TableSplitView
      operatingHours={operatingHours}
      operatingHoursMargin={parentItem.data?.metadata?.configuration?.operating_hours_margin || 1800}
      headerData={hdrData}
      rows={rows}
      projection={proj}
      selected={selected} />
  )
  
}
